// ISLR según el tipo de persona del proveedor: mismo cálculo que
// backend/src/utils/retencionIslr.js. V, E y P = persona natural; J, G, C
// (o sin RIF) = jurídica.

export function tipoPersona(rif) {
  const letra = String(rif || '').trim().toUpperCase().charAt(0);
  return ['V', 'E', 'P'].includes(letra) ? 'natural' : 'juridica';
}

export const TIPO_PERSONA_LABEL = { natural: 'Persona natural', juridica: 'Persona jurídica' };

export function valoresIslr(cod, tipo) {
  if (!cod) return { porcentaje: null, sustraendo: null };
  return tipo === 'natural'
    ? { porcentaje: cod.porcentaje, sustraendo: cod.sustraendo }
    : { porcentaje: cod.porcentaje_juridica, sustraendo: cod.sustraendo_juridica };
}

// Proveedor con el botón "Retenciones" ya guardado.
export const retencionesConfiguradas = (p) => p != null && p.retencion_iva_pct != null;
